import React, { useState } from "react";
import { DefaultPageLayout } from "../../../../ui/layouts/DefaultPageLayout";
import { Button } from "../../../../ui/components/Button";
import { Tabs } from "../../../../ui/components/Tabs";
import { FeatherArrowLeft } from "@subframe/core";
import { useNavigate } from "react-router-dom";
import TemplateDownloadSection from "../components/TemplateDownloadSection";
import UploadSection from "../components/UploadSection";
import { useToast } from "../../../../shared/presentation/components";

export const CustomerVendorUploadPage: React.FC = () => {
  const navigate = useNavigate();
  const { showSuccess, showError, showWarning } = useToast();
  const [activeTab, setActiveTab] = useState<"customers" | "vendors">(
    "customers",
  );

  const handleError = (message: string) => {
    showError(message);
  };

  const handleSuccess = (message: string) => {
    showSuccess(message);
  };

  const handleWarning = (message: string) => {
    showWarning(message);
  };

  return (
    <DefaultPageLayout>
      <div className="flex h-full w-full flex-col items-start">
        {/* Header Section */}
        <div className="flex w-full flex-col items-start gap-4 border-b border-solid border-neutral-border bg-default-background px-8 py-6">
          <Button
            variant="brand-secondary"
            icon={<FeatherArrowLeft />}
            onClick={() => navigate("/admin")}
          >
            Back to Dashboard
          </Button>
          <div className="flex w-full flex-col items-start gap-1">
            <span className="text-heading-2 font-heading-2 text-default-font">
              Customer & Vendor Bulk Upload
            </span>
            <span className="text-body font-body text-subtext-color">
              Download Excel templates, fill them with your data, and upload to
              bulk import customers and vendors into the system.
            </span>
          </div>
        </div>

        {/* Content Section with Scrolling */}
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-8 overflow-y-auto bg-default-background px-8 py-8">
          {/* Template Download Section */}
          <div className="w-full">
            <TemplateDownloadSection
              onError={handleError}
              onSuccess={handleSuccess}
            />
          </div>

          {/* Upload Sections with Tabs */}
          <div className="flex w-full flex-col items-start gap-6">
            <div className="flex w-full flex-col items-start gap-2">
              <span className="text-heading-2 font-heading-2 text-default-font">
                Upload Filled Templates
              </span>
              <span className="text-body font-body text-subtext-color">
                Select whether you want to upload customers or vendors, then
                upload your filled Excel file.
              </span>
            </div>

            {/* Tabs */}
            <Tabs>
              <Tabs.Item
                active={activeTab === "customers"}
                onClick={() => setActiveTab("customers")}
              >
                Customers
              </Tabs.Item>
              <Tabs.Item
                active={activeTab === "vendors"}
                onClick={() => setActiveTab("vendors")}
              >
                Vendors
              </Tabs.Item>
            </Tabs>

            {/* Upload Section */}
            <div className="w-full">
              <UploadSection
                type={activeTab}
                onError={handleError}
                onSuccess={handleSuccess}
                onWarning={handleWarning}
              />
            </div>
          </div>
        </div>
      </div>
    </DefaultPageLayout>
  );
};
